import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery";

export const businessApi = createApi({
  reducerPath: "businessApi",
  baseQuery: axiosBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_HOST}/api`,
  }),
  endpoints: (build) => ({
    getBusinesses: build.query({
      query(params) {
        const queryParams = new URLSearchParams(params).toString();
        return {
          url: `/admin/businesses/?${queryParams}`,
          method: "GET",
        };
      },
      providesTags: ["Businesses"],
    }),
    getBusinessById: build.query({
      query(id) {
        return {
          url: `/admin/businesses/${id}`,
          method: "GET",
        };
      },
      providesTags: ["Business"],
    }),
    getBusinessByNui: build.query({
      query(nui) {
        return {
          url: `/admin/businesses/nui/${nui}`,
          method: "GET",
        };
      },
      providesTags: ["Business"],
    }),
  }),
});

export const {
  useGetBusinessesQuery,
  useLazyGetBusinessesQuery,
  useGetBusinessByIdQuery,
  useGetBusinessByNuiQuery,
} = businessApi;
